import RecommendedModal from './RecommendedModal.vue'

export default RecommendedModal
